import CstVerifyFailure from 'features/auth/components/screens/CstVerifyFailure';
import React from 'react';

export default function CstLinkVerifyFailure() {
  return <CstVerifyFailure />;
}
